<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg {width} {height} viewBox="0 0 17 18" {fill} xmlns="http://www.w3.org/2000/svg">
	<g opacity="0.5">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.50016 1.20898C4.19695 1.20898 0.708496 4.69743 0.708496 9.00065C0.708496 13.3038 4.19695 16.7923 8.50016 16.7923C12.8034 16.7923 16.2918 13.3038 16.2918 9.00065C16.2918 4.69743 12.8034 1.20898 8.50016 1.20898ZM6.43938 2.96609C5.10047 3.4232 3.96219 4.31338 3.19159 5.46959L4.00233 7.30662L6.38856 7.89806L7.76222 6.85836V3.89681L6.43938 2.96609ZM9.23555 3.91213V6.85653L10.2957 7.659L12.9436 6.6485L13.5397 5.09591C12.7845 4.12256 11.7535 3.3739 10.564 2.96712L9.23555 3.91213ZM14.875 8.96113L13.5604 7.99007L10.9053 9.00334L10.3469 10.7939L11.6462 12.9267L13.2774 13.222C14.2717 12.0976 14.8752 10.6196 14.8752 9.00065C14.8752 8.98748 14.8751 8.9743 14.875 8.96113ZM9.8404 15.2346L10.3875 13.6767L9.11131 11.4798H7.51388C7.50602 11.4798 7.49815 11.4797 7.49029 11.4795L6.23117 13.0233L6.21227 14.9528C6.92242 15.2259 7.6938 15.3757 8.50016 15.3757C8.95987 15.3757 9.40825 15.327 9.8404 15.2346ZM2.96094 12.1584L5.05372 12.1359L6.51359 10.3461L6.20969 9.37168L3.48893 8.69727L2.16075 9.67831C2.25531 10.5732 2.53505 11.413 2.96094 12.1584Z"
			{fill}
		/>
	</g>
</svg>
